class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const firstAddedItem =
      parsedState && Array.isArray(parsedState.items) && parsedState.items.length > 0 ? parsedState.items[0] : null;
    this.cartItemKey =
      (parsedState && parsedState.key) ||
      (firstAddedItem && firstAddedItem.key) ||
      (parsedState && parsedState.id) ||
      null;
    const sections = parsedState && parsedState.sections ? parsedState.sections : {};
    this.getSectionsToRender().forEach((section) => {
      const targetElement = document.getElementById(section.id);
      if (!targetElement) return;
      const sectionHtml = this.getSectionInnerHTML(sections[section.id], section.selector);
      if (typeof sectionHtml === 'string') {
        targetElement.innerHTML = sectionHtml;
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartItemKey
          ? `[id="cart-notification-product-${this.cartItemKey}"]`
          : '[id^="cart-notification-product-"]',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string' || !html.length) return null;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const target =
      (selector ? parsed.querySelector(selector) : null) ||
      (!selector ? (parsed.querySelector('.shopify-section') || parsed.body) : null) ||
      (!selector || selector === '.shopify-section' ? parsed.body : null);
    return target ? target.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
